/**
 * Whether an assistant answer's content is final.
 *
 * The backend flow-message store only ever persists `pending | processed |
 * failed | cancelled` — a successful final answer settles as **`processed`**.
 * But a freshly-streamed answer briefly carries the transient *client* status
 * **`done`**: the websocket handler sets `status = "done"` from the final
 * content delta (see `useHandleWebSocketEvent`), and it stays that way in the
 * query cache until a refetch replaces it with the persisted `processed`.
 *
 * Treating both as complete lets the UI settle the moment streaming finishes
 * rather than waiting for the refetch. Use this single predicate everywhere an
 * answer's "is it done?" is decided so the two statuses never drift apart.
 */
export function isAnswerComplete(status: string | undefined): boolean {
  return status === "processed" || status === "done";
}
